import asbisRobotImage from 'images/robot_asbis.png'
import asbisWelderRobotImage from 'images/robot_asbis_welder.png'
import autonomicsBlueRobotImageComboOmni from 'images/robot_blue_combo_omni.png'
import autonomicsBlueRobotImageSw from 'images/robot_blue_sw.png'
import autonomicsBlueRobotImageSwsc from 'images/robot_blue_swsc.png'
import autonomicsComboOmniWhiteRobotImage from 'images/robot_combo_omni_white.png'
import gausiumRobotImage from 'images/robot_gausium.jpg'
import autonomicsGreenRobotImageComboOmni from 'images/robot_green_combo_omni.png'
import autonomicsGreenRobotImageSw from 'images/robot_green_sw.png'
import autonomicsGreenRobotImageSwsc from 'images/robot_green_swsc.png'
import gs40RobotImage from 'images/robot_gs_40.png'
import gs75RobotImage from 'images/robot_gs_75.png'
import gsOmnieRobotImage from 'images/robot_gs_omnie.png'
import gsPhantasRobotImage from 'images/robot_gs_phantas.png'
import autonomicsOrangeRobotImageComboOmni from 'images/robot_orange_combo_omni.png'
import autonomicsOrangeRobotImageSw from 'images/robot_orange_sw.png'
import autonomicsOrangeRobotImageSwsc from 'images/robot_orange_swsc.png'
import autonomicsPinkRobotImageComboOmni from 'images/robot_pink_combo_omni.png'
import autonomicsPinkRobotImageSw from 'images/robot_pink_sw.png'
import autonomicsPinkRobotImageSwsc from 'images/robot_pink_swsc.png'
import autonomicsPurpleRobotImageComboOmni from 'images/robot_purple_combo_omni.png'
import autonomicsPurpleRobotImageSw from 'images/robot_purple_sw.png'
import autonomicsPurpleRobotImageSwsc from 'images/robot_purple_swsc.png'
import autonomicsWhiteRobotImage from 'images/robot_white.png'
import autonomicsYellowRobotImageComboOmni from 'images/robot_yellow_combo_omni.png'
import autonomicsYellowRobotImageSw from 'images/robot_yellow_sw.png'
import autonomicsYellowRobotImageSwsc from 'images/robot_yellow_swsc.png'
import { useSelector } from 'react-redux'
import { selectRobot } from 'store/selectors/robot'
import { VENDOR } from 'utils/vendorDisplayName'

import style from './RobotImage.module.css'

const isComboOmniType = (robotType: string) => robotType === 'comboomni' || robotType === 'combo omni'

const RobotImage = () => {
  const robot = useSelector(selectRobot)
  const isGausium = robot.robotInfo?.vendor === VENDOR.GAUSIUM
  const isAsbis = robot.robotInfo?.vendor === VENDOR.ASBIS
  const robotColor = robot.robotInfo?.robot_color
  const robotType = robot.robotInfo?.robot_type?.toLowerCase() || ''
  const isComboOmni = isComboOmniType(robotType)
  const isSwsc = robotType === 'combo' || robotType.includes('scrub')

  const getRobotImage = () => {
    if (isAsbis) {
      const asbisType = (robot.robotInfo?.robot_type || '').toLowerCase().trim()
      if (asbisType === 'welder') return asbisWelderRobotImage
      return asbisRobotImage
    }

    if (isGausium) {
      const gsType = (robot.robotInfo?.robot_type || '').toString().trim()
      if (gsType === '40') return gs40RobotImage
      if (gsType === '50') return gsOmnieRobotImage
      if (gsType === '75') return gs75RobotImage
      if (gsType.toUpperCase() === 'S') return gsPhantasRobotImage
      return gausiumRobotImage
    }

    if (isComboOmni) {
      switch (robotColor) {
        case 'Blue':
          return autonomicsBlueRobotImageComboOmni
        case 'Green':
          return autonomicsGreenRobotImageComboOmni
        case 'Yellow':
          return autonomicsYellowRobotImageComboOmni
        case 'Orange':
          return autonomicsOrangeRobotImageComboOmni
        case 'White':
          return autonomicsComboOmniWhiteRobotImage
        case 'Pink':
          return autonomicsPinkRobotImageComboOmni
        case 'Purple':
          return autonomicsPurpleRobotImageComboOmni
        default:
          return autonomicsPinkRobotImageComboOmni
      }
    }

    switch (robotColor) {
      case 'Blue':
        return isSwsc ? autonomicsBlueRobotImageSwsc : autonomicsBlueRobotImageSw
      case 'Green':
        return isSwsc ? autonomicsGreenRobotImageSwsc : autonomicsGreenRobotImageSw
      case 'Yellow':
        return isSwsc ? autonomicsYellowRobotImageSwsc : autonomicsYellowRobotImageSw
      case 'Orange':
        return isSwsc ? autonomicsOrangeRobotImageSwsc : autonomicsOrangeRobotImageSw
      case 'White':
        return autonomicsWhiteRobotImage
      case 'Pink':
        return isSwsc ? autonomicsPinkRobotImageSwsc : autonomicsPinkRobotImageSw
      case 'Purple':
        return isSwsc ? autonomicsPurpleRobotImageSwsc : autonomicsPurpleRobotImageSw
      default:
        // Default to Pink SWSC if nothing matches
        return autonomicsPinkRobotImageSwsc
    }
  }

  return <img src={getRobotImage()} alt="robot" className={style.robotImage} />
}

export default RobotImage
